import { Icon20PicturePlusOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type RefObject, memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addNewBackground } from 'reactApp/modules/aiTools/aiTools.module';
import { name } from 'reactApp/modules/aiTools/helpers/constants';
import { sendDwhButton, sendDwhDialog } from 'reactApp/modules/dwh/dwh.helpers';
import { openSelectFromCloudPopup } from 'reactApp/sections/AlbumsPage/SelectFromCloudPopup/SelectFromCloudPopup.helpers';
import { Delimiter } from 'reactApp/ui/ReactViewer/AiImprove/Buttons';

import styles from './AiImproveToolbar.css';
import { BackgroundSelector, backgroundSelectorId } from './BackgroundSelector/BackgroundSelector';
import { getItemById, useGetItems } from './BackgroundSelector/BackgroundSelector.helpers';

export const AddBackgroundButton = memo<{
    pathId: string;
    isNewbackground?: boolean;
}>(function AddBackground({ pathId, isNewbackground }) {
    const ref = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const [showDialog, setShowDialog] = useState(false);
    const [activeBackgroundId, setActiveBackgroundId] = useState('transparent');

    const items = useGetItems();

    useEffect(() => {
        sendDwhButton({ name, button_name: 'add_background' });
    }, []);

    const showClick = useCallback(() => {
        setShowDialog(!showDialog);
        if (!showDialog) {
            sendDwhDialog({ name, action: 'show' });
        }
        sendDwhButton({ name, action: 'click', button_name: 'add_background' });
    }, [showDialog]);

    const handleClose = useCallback(() => {
        setShowDialog(false);
    }, []);

    const selectItem = useCallback(
        (newId: string) => {
            setActiveBackgroundId(newId);

            const { id, type, backgroundImage } = getItemById(newId) || {
                id: newId,
                type: 'cloud',
            };

            dispatch(
                addNewBackground({
                    pathId,
                    id: (type === 'cloud' || type === 'mail') && backgroundImage ? backgroundImage : id,
                    type,
                })
            );

            sendDwhButton({ name, action: 'click', button_name: 'select_background', data: { type, id } });
        },
        [dispatch, pathId]
    );

    const handleSelectFromCloud = useCallback(() => {
        openSelectFromCloudPopup({
            onClose: () => {},
            onSuccess: () => selectItem(''),
            titleText: 'Выбрать фон',
            submitBttnText: 'Выбрать фон',
            isEmpty: false,
            emptyText: 'Загрузите фото или видео',
            oneFileOnly: true,
        });
    }, [selectItem]);

    return (
        <>
            <div className={styles.addBackWrapper}>
                <div
                    className={classNames(styles.button, { [styles.button_active]: showDialog })}
                    onClick={showClick}
                    data-qa-id="add-backgrdound-bttn"
                    data-no-close-tooltip={backgroundSelectorId}
                    ref={ref}
                >
                    <Icon20PicturePlusOutline data-qa-id="add-back-icon" />
                    {isNewbackground ? 'Изменить фон' : 'Добавить фон'}
                </div>
                {showDialog && (
                    <BackgroundSelector
                        target={ref as RefObject<HTMLDivElement>}
                        items={items}
                        activeBackgroundId={activeBackgroundId}
                        onSelectItem={selectItem}
                        onSelectFromCloud={handleSelectFromCloud}
                        isNewbackground={isNewbackground}
                        onClose={handleClose}
                    />
                )}
            </div>
            <Delimiter />
        </>
    );
});

AddBackgroundButton.displayName = 'RatingAddBackgroundBlock';
